import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const handleDeleteUser = async (userId, token, fetchUsers) => {
  if (window.confirm("¿Seguro que deseas eliminar este usuario?")) {
    try {
      await axios.delete(`${API_URL}/users/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUsers();
    } catch (err) {
      alert("Error al eliminar usuario.");
    }
  }
};

export const handleEditUser = (user) => {
  alert(`Editar usuario: ${user.username}`);
  ///AGREGAR PUT
};

export const fetchUsers = async (token, setUsers, setLoading) => {
  try {
    const response = await axios.get(`${API_URL}/users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setUsers(response.data);
  } catch (err) {
    setUsers([]);
  } finally {
    setLoading(false);
  }
};

export const handleLoginSubmit = async (form, setError, navigate) => {
  try {
    const response = await axios.post(`${API_URL}/users/login`, form);
    const { access_token, profile_id, full_name, username, mail } = response.data;

    localStorage.setItem("token", access_token);
    localStorage.setItem("profile_id", profile_id);
    localStorage.setItem("full_name", full_name);
    localStorage.setItem("username", username);
    localStorage.setItem("mail", mail);

    navigate("/dashboard");
  } catch (err) {
    let errorMsg = "Error al agregar usuario.";
    if (err.response?.data) {
      if (typeof err.response.data === "string") {
        errorMsg = err.response.data;
      } else if (err.response.data.msg) {
        errorMsg = err.response.data.msg;
      } else if (err.response.data.message) {
        errorMsg = err.response.data.message;
      }
    } else if (err.message) {
      errorMsg = err.message;
    }
    //setError("Usuario o contraseña incorrectos");
    setError(errorMsg);
  }
};

export const handleChangePassword = async ({
  e,
  username,
  currentPassword,
  newPassword,
  confirmPassword,
  setMessage,
  setCurrentPassword,
  setNewPassword,
  setConfirmPassword,
}) => {
  e.preventDefault();
  setMessage("");
  if (!currentPassword || !newPassword || !confirmPassword) {
    setMessage("Completa todos los campos.");
    return;
  }
  if (newPassword !== confirmPassword) {
    setMessage("Las contraseñas nuevas no coinciden.");
    return;
  }
  if (currentPassword === newPassword) {
    setMessage("La nueva contraseña debe ser distinta a la actual.");
    return;
  }
  try {
    const token = localStorage.getItem("token");
    await axios.post(
      `${API_URL}/users/change-password`,
      {
        username: username,
        old_password: currentPassword,
        new_password: newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setMessage("Contraseña modificada exitosamente.");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  } catch (err) {
    setMessage("Error al cambiar la contraseña.");
  }
};

export const handleNuevoUsuarioSubmit = async ({
  e,
  newUser,
  token,
  setMessage,
  setNewUser,
  onUserAdded,
  onClose,
}) => {
  e.preventDefault();
  setMessage("");
  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/users`,
      newUser,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setMessage("Usuario agregado exitosamente.");
    setNewUser({
      username: "",
      full_name: "",
      mail: "",
      profile_id: "",
      password: "",
    });
    onUserAdded();
    onClose();
  } catch (err) {
    let errorMsg = "Error al agregar usuario.";
    if (err.response?.data) {
      if (typeof err.response.data === "string") {
        errorMsg = err.response.data;
      } else if (err.response.data.msg) {
        errorMsg = err.response.data.msg;
      } else if (err.response.data.message) {
        errorMsg = err.response.data.message;
      }
    } else if (err.message) {
      errorMsg = err.message;
    }
    setMessage(errorMsg);
  }
};

export const fetchProfiles = async (token, setProfiles) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setProfiles(response.data);
  } catch {
    setProfiles([]);
  }
};

export const validarSesion = async (token) => {
  try {
    await axios.get(`${process.env.REACT_APP_API_URL}/users/session`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return true;
  } catch (err) {
    if (err.response && err.response.status === 401) {
      return false;
    }
    throw err;
  }
};

export const handleLogout = async () => {
  const token = localStorage.getItem("token");
  try {
    await axios.post(
      `${API_URL}/users/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (err) {
    console.error("❌ Error al cerrar sesión:", err.response?.data || err.message);
  } finally {
    localStorage.removeItem("token");
    localStorage.removeItem("profile_id");
    if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  }
};